module.exports = __webpack_public_path__ + "img/b4167b8.jpg";